import React, { useState } from 'react';
import './employerform1.css';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate , Link} from 'react-router-dom';
import bar02 from '../../../images/bar02.svg';
import { Container, Form, Button, Row, Col, Image } from 'react-bootstrap';

function Employerform2() {
  const [linkedInInstagram, setLinkedInInstagram] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleLinkedInInstagramChange = (event) => {
    setLinkedInInstagram(event.target.value);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(`LinkedIn/Instagram: ${linkedInInstagram}, Email: ${email}, Password: ${password}, Confirm Password: ${confirmPassword}`);
  };

  const navigate = useNavigate();

  return (
    <Container fluid className='p-0 m-0'>
      <div className='d-flex align-items-center text-center  gap-4 py-5 px-3'>
      <FaArrowLeft className='arrow' onClick={() => navigate("/employerform1")} />
      <h3 className='mt-4'>Back</h3>
      </div>
      <Container fluid className='p-3 p-sm-5' style={{ background: 'rgba(255, 161, 94, 0.55)',
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)'}}>
        <div className='d-block align-items-center justify-content-center text-center py-3'>
        <Image fluid src={bar02} alt='bar' />
        <h2 className='form-head mt-4'>Company Details</h2>
        </div>
        <Form onSubmit={handleSubmit} className='mt-5' >
        <Row className='gap-0 gap-sm-5 mt-4'>
          <Col xs={12} sm={true}>
          <Form.Group controlId="" className='mb-4'>
                <Form.Label className='form-text-label'>LinkedIn / Instagram</Form.Label>
                <Form.Control type='text' value={linkedInInstagram} onChange={handleLinkedInInstagramChange} placeholder="Enter LinkedIn or Instagram username" style={{border: '1px solid #005EB5',
               borderRadius: '60px'}} className='py-2'/>
          </Form.Group>
          <Form.Group controlId="email" className='mb-4'>
                <Form.Label className='form-text-label'>Enter Email</Form.Label>
                <Form.Control type='email' value={email} onChange={handleEmailChange} placeholder="Enter email address" style={{border: '1px solid #005EB5',
borderRadius: '60px'}} className='py-2' />
          </Form.Group>
          </Col>
          <Col xs={12} sm={true}>
          <Form.Group controlId="password" className='mb-4'>
                <Form.Label className='form-text-label'>Enter Password:</Form.Label>
                <Form.Control type='password' value={password} onChange={handlePasswordChange} placeholder="*******" style={{border: '1px solid #005EB5',
borderRadius: '60px'}} className='py-2'/>
          </Form.Group>
          <Form.Group controlId="password" className='mb-4'>
                <Form.Label className='form-text-label'>Confirm Password:</Form.Label>
                <Form.Control type='password' value={confirmPassword} onChange={handleConfirmPasswordChange}placeholder="*******" style={{border: '1px solid #005EB5',
borderRadius: '60px'}} className='py-2'/>
          </Form.Group>
          </Col>
        </Row>
        <div className='mt-3 d-flex text-center justify-content-center align-items-center mx-3'> 
        <Link to="/employerform3" className='next-button'>Next
          </Link>
        </div>
        </Form>

      </Container>
   
    </Container>
    
  );
}

export default Employerform2;
